function Navbar({ toggleSidebar, isCollapsed }) {
    const adminEmail = localStorage.getItem("email") || "Admin";

    return (
        <div style={{
            height: "72px",
            background: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 32px",
            borderBottom: "1px solid var(--border)",
            position: "sticky",
            top: 0,
            zIndex: 10
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                <button
                    onClick={toggleSidebar}
                    style={{
                        background: "#f1f5f9",
                        border: "none",
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: "var(--text-muted)",
                        transition: "all 0.2s"
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = "var(--primary)"}
                    onMouseOut={(e) => e.currentTarget.style.color = "var(--text-muted)"}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        {isCollapsed ? (
                            <path d="M13 17l5-5-5-5M6 17l5-5-5-5" />
                        ) : (
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                        )}
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </button>
                <h3 style={{ margin: 0, color: "var(--text-dark)", fontSize: "1.1rem", fontWeight: "600" }}>
                    Kannada Community CMS
                </h3>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: "0.85rem", fontWeight: "700", color: "var(--text-dark)" }}>System Administrator</div>
                    <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>{adminEmail}</div>
                </div>
                <div style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "12px",
                    background: "linear-gradient(135deg, var(--primary), var(--primary-light))",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    boxShadow: "0 4px 6px -1px rgba(99, 102, 241, 0.2)"
                }}>
                    {adminEmail.charAt(0).toUpperCase()}
                </div>
            </div>
        </div>
    );
}

export default Navbar;